module.exports = __webpack_public_path__ + "img/ic_upload.f1c34fd1.svg";